import React, { useState } from 'react'
import Checkout from '../components/Checkout'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import Cart from '../components/Cart'

export default function CheckOutPage() {
    const [cart, setcart] = useState<boolean>(false)

    const openCart = () => {
        setcart(!cart);
    }
    return (
        <>
            <Navbar openCart={openCart} />
            <Checkout />
            <Footer />
            {cart === true ? <Cart openCart={openCart} /> : ""}
        </>
    )
}
